"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
require("swiper/css");
require("swiper/css/navigation");
require("swiper/css/pagination");
class Carousel {
    constructor(selector = '.world__swiper') {
        this.selector = selector;
        this.initSwiper();
    }
    initSwiper() {
        this.swiper = new swiper_1.default(this.selector, {
            modules: [modules_1.Navigation, modules_1.Pagination],
            slidesPerView: 'auto',
            spaceBetween: 65,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.custom-next',
                prevEl: '.custom-prev',
            },
            pagination: {
                el: '.swiper-pagination.custom-pagination',
                clickable: true,
            },
            breakpoints: {
                0: {
                    spaceBetween: 20,
                },
                768: {
                    spaceBetween: 40,
                },
                1024: {
                    spaceBetween: 50,
                },
                1200: {
                    spaceBetween: 60,
                },
                1440: {
                    spaceBetween: 70,
                },
                1680: {
                    spaceBetween: 80,
                },
                1920: {
                    spaceBetween: 90,
                },
                2200: {
                    spaceBetween: 100,
                },
            },
        });
    }
}
exports.Carousel = Carousel;
